import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const VendorsContainer = styled(View)`
  padding: 40px;
`;

export const ModalContainer = styled(Pressable)`

`;

export const VendorsShowContainer = styled(View)`
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ButtonContainer = styled(View)`

`;

export const VendorDemographicContainer = styled(View)`
  padding: 10px;
  max-width: 400px;
`;

